import React from 'react';
import Icon from 'elektra-iconos';
import styles from './header.sass';
import QALogo from './QA.svg';

const Header = () => {
  return (
    <header className={styles.header}>
      <Icon icon="logoElektra" className={styles.logo} />
      {process.env.ENV === 'QA' && <img src={QALogo} alt="QALogo" className={styles.logo} />}
    </header>
  );
};

export default Header;
